<template>
    <div>
        <div class="home-header home-box">
            <div class="left">
                <img src="./../assets/img/cnLogo.png" alt="">
            </div>
            <div class="left-title">
                <p class="one">酒店及自游行产品交易平台</p>
                <p class="tow">龙腾捷旅订房集团旗下站点</p>
            </div>
            <div class="header-r">
                <div class="language" @mouseover="languageShow=true" @mouseout="languageShow=false">
                    <div class="country"></div>
                    <div class="text">{{viewFont}}
                        <ul v-show="languageShow">
                            <li @click="onSwitchLanguage('s')">
                                <span class="one"></span>简体中文
                            </li>
                            <li @click="onSwitchLanguage('t')">
                                <span class="one"></span>繁体中文
                            </li>
                            <li @click="changeLang()">
                                <span class="two"></span>English
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="right">
                <router-link to="login" :class="$route.name=='Login'?'active':''">首页</router-link>
                <router-link to="introduction" :class="$route.name=='introduction'?'active':''">预订须知</router-link>
                <router-link to="cooperation" :class="$route.name=='cooperation'?'active':''">合作加盟</router-link>
                <router-link to="contact" :class="$route.name=='contact'?'active':''">联系我们</router-link>
                <router-link to="about" style="margin-right:0px;" :class="$route.name=='about'?'active':''">关于我们</router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props:{
			lang:{
				type:String,
				default:''
			}
		},
  data() {
    return {
      languageShow: false,
      viewFont:"简体"
    };
  },
  mounted(){
    if(this.lang=='zhF'){
        this.onSwitchLanguage('t')
      }else if(this.lang=='zh'){
        this.onSwitchLanguage('s')
      }
  },
  methods: {
    changeLang() {
      window.location.href = "http://en.dingfangyi.com/";
    },
    // 字体切换
    onSwitchLanguage(val) {
      // this.lang = val;
      if (val == "s") {
        //简体
        this.viewFont = "简体";
        localStorage.setItem("lang", "s");
      } else if(val == "t"){
        //繁体
        this.viewFont = "繁体";
        localStorage.setItem("lang", "t");
      }
      this.$zh_tran(localStorage.getItem("lang"));
    }
  }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/loginHeader.vue